export default __webpack_public_path__ + "static/rtm_ss_1_2-232fb4509cdf5bcc00eaee5e908be174.jpg";